import { tv } from "../../../variants/tv.js";
const toolbarButtonVariants = tv({
    slots: {
        root: 'relative flex h-full max-h-14 min-h-10 max-w-12 min-w-10 flex-col items-center justify-center rounded-xl',
        flexSlot: 'relative flex flex-col items-center gap-1 p-1',
        iconSlot: 'size-6 shrink-0 text-primary-13',
        labelSlot: 'text-body3 leading-4 font-medium text-primary-13'
    },
    variants: {
        as: {
            button: {
                root: 'hover:cursor-pointer hover:bg-primary-3'
            },
            div: {}
        },
        emphasis: {
            regular: {},
            medium: {
                labelSlot: 'text-primary-1',
                iconSlot: 'text-primary-1'
            },
            bold: {
                labelSlot: 'text-primary-1',
                iconSlot: 'text-primary-1'
            }
        },
        animate: {
            true: {
                labelSlot: 'overflow-hidden'
            },
            false: {}
        },
        hasLabel: {
            true: '',
            false: {
                labelSlot: 'hidden'
            }
        }
    },
    compoundVariants: [
        {
            as: 'button',
            emphasis: 'medium',
            class: {
                root: 'hover:bg-primary-11'
            }
        },
        {
            as: 'button',
            emphasis: 'bold',
            class: {
                root: 'hover:bg-primary-13/20'
            }
        }
    ],
    defaultVariants: {
        as: 'button',
        emphasis: 'medium',
        animate: false,
        hasLabel: true
    }
});
const toolbarButtonVariantKeys = Object.keys(toolbarButtonVariants.variants);
export { toolbarButtonVariantKeys, toolbarButtonVariants };
